module.exports = __webpack_public_path__ + "img/iot.dd16ba87.png";